var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLuggageUnderSeat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "41FDD66B-41DE-4AF2-AF37-5CF276518FEC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KLM-Viewports",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KLM-FE-1218",
    transform: "translate(-517, -1181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transavia/NotAble/1440-Copy",
    transform: "translate(16, 954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Small/Hand-luggage-b",
    transform: "translate(501, 227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.25,36.75 C35.175,36.75 36.75,38.325 36.75,40.25 L36.75,47.25 C36.75,49.175 35.175,50.75 33.25,50.75 L22.75,50.75 C20.825,50.75 19.25,49.175 19.25,47.25 L19.25,40.25 C19.25,38.325 20.825,36.75 22.75,36.75 Z M28,5.25 C32.2,5.25 35.525,9.625 35.525,15.05 L35.525,15.4 C42.35,18.375 45.15,26.95 45.5,44.625 C45.5,47.075 43.575,49 41.125,49 L40.075,49 C40.075,48.475 40.25,47.775 40.25,47.25 L40.25,40.25 C40.25,36.4 37.1,33.25 33.25,33.25 L22.75,33.25 C18.9,33.25 15.75,36.4 15.75,40.25 L15.75,47.25 C15.75,47.775 15.925,48.475 15.925,49 L14.875,49 C12.425,49 10.5,47.075 10.5,44.625 C10.85,26.95 13.65,18.375 20.475,15.4 L20.475,15.05 C20.475,9.625 23.8,5.25 28,5.25 Z M17.675,12.95 C16.275,13.65 15.05,14.7 14,15.75 C11.725,15.575 9.8,16.275 8.4,18.9 C7,21.7 6.475,26.425 7.875,31.325 C7.525,33.425 7.35,35.875 7.175,38.5 C2.8,30.8 2.975,21.875 5.425,17.15 C7.7,12.775 12.075,11.375 17.675,12.95 Z M38.325,12.775 C43.925,11.2 48.3,12.6 50.575,16.975 C53.025,21.7 53.2,30.625 48.65,37.975 C48.475,35.525 48.3,33.075 47.95,30.8 C49.35,25.9 48.825,21.175 47.425,18.375 C46.2,16.1 44.275,15.4 42,15.575 C40.95,14.525 39.725,13.475 38.325,12.775 Z M28,8.75 C25.9,8.75 24.15,11.2 23.975,14.35 C25.2,14.175 26.6,14 28,14 C29.4,14 30.8,14.175 32.025,14.35 C31.85,11.2 30.1,8.75 28,8.75 Z",
    id: "Combined-Shape",
    fill: "#00A1DE"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggageUnderSeat);
export default __webpack_public_path__ + "static/media/luggage_under_seat.c18cfd2c2c03ff0f36a8c8b42a6c3455.svg";
export { ForwardRef as ReactComponent };